"use client";
import Header from "@/src/components/layout/header/Header";
import Footer from "@/src/components/layout/footer/Footer";
import TemporaryAuthModal from "@/src/components/custom/TemporaryAuthModal";
import { persistQueryClient } from '@tanstack/react-query-persist-client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister'
import { useState, useEffect } from 'react'

const CACHE_VERSION = process.env.NEXT_PUBLIC_CACHE_VERSION || '1';

export default function MainLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  // Create QueryClient only once using useState
  const [queryClient] = useState(() => new QueryClient({
    defaultOptions: {
      queries: {
        gcTime: 1000 * 60 * 60 * 24, // 24 hours
        staleTime: 1000 * 60 * 5, // 5 minutes
      },
    },
  }))

  // Setup persistence only on client-side
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const localStoragePersister = createSyncStoragePersister({
        storage: window.localStorage,
      })

      persistQueryClient({
        queryClient,
        persister: localStoragePersister,
        maxAge: 1000 * 60 * 60 * 24, // 24 hours
        buster: CACHE_VERSION, // Automatically clears cache when version changes
      })

      console.log(`🔄 React Query cache initialized with version: ${CACHE_VERSION}`)
    }
  }, [queryClient])

  return (
    <QueryClientProvider client={queryClient}>
      <TemporaryAuthModal />
      <Header />
      {children}
      <Footer />
    </QueryClientProvider>
  );
}
